/**
 * ajax 请求的封装
 */
import axios from 'axios'
import {Loading, Notification} from 'element-ui';
import APIPath from "@/utils/APIPath";
import storage from '@/utils/storage'
import Router from '@/router/index'
import {BASE_URL} from '@/config/config'
import utils from "@/utils/utils";
import md5 from "js-md5";
import i18nFile from '@/i18n/index'
const Base64 = require('js-base64').Base64

let loadingInstance,
  loginParam = {
    lock: false,
    requestIng: false,
    queue: []
  }

const httpClient = {
  request(param) {
    return new Promise((resolve, reject) => {
      const urlData = []
      let header = {},
        data = {
          ...(param.data || {}),
          lang: storage.getLang() || '1'
        }

      if (param.noToken) delete data.auth;
      if (param.header) header = Object.assign({}, header, param.header);
      if (param.data) data = utils.objNumberToString(Object.assign({}, data, param.data));

      param.method = param.method || 'get'

      header['Content-Type'] = param.formData ? 'multipart/form-data;charset=UTF-8' : 'application/json;charset=UTF-8'

      if ((param.method.toLocaleLowerCase() === 'get' || param.method.toLocaleLowerCase() === 'delete') && data &&
        typeof data === 'object') {
        for (let i in data) {
          urlData.push(`${i}=${data[i]}`)
        }
        param.url += urlData.length > 0 ? (param.url.indexOf('?') > -1 ? '&' : '?') + urlData.join('&') : ''
        data = {}
      }
      else {
        if (param.formData) {
          const formData = new FormData();
          for (let i in data) {
            formData.append(i, data[i]);
          }
          data = formData
        } else {
          // const a = utils.cloneObject(data)
          // debugger

          // data = JSON.stringify(data)
        }
      }
      const url = `${(param.httpHost || (BASE_URL + '/'))}${param.url}`

      axios({
        url,
        data: data,
        headers: header,
        method: param.method,
      }).then(res => {
        // if (!param.noLoading) loadingInstance.close()
        if (param.noCheck) {
          resolve(res.data)
        } else {
          this.checkCode(res, resolve, reject, url)
        }
      }).catch(function (error) {
        // loadingInstance.close()
        // utils.messageError(i18nFile.getI18nText('lang.comm.网络异常'))
        reject(error)
      })
    })
  },

  post(param) {
    return this.request({
      ...param,
      method: 'post'
    })
  },
  get(param) {
    return this.request({
      ...param,
      method: 'get'
    })
  },
  delete(param) {
    return this.request({
      ...param,
      method: 'delete'
    })
  },

  // 校验code并处理下一步操作
  checkCode(res, resolve, reject, url) {
    let text = '';
    switch (res.data.code) {
      case 200:
        resolve(res.data)
        return;
      default:
        reject(res.data)
        // utils.messageError(res.data.msg || i18nFile.getI18nText('lang.comm.未知错误'))
    }
  },
}
export default httpClient




// WEBPACK FOOTER //
// ./src/utils/httpClient.js